import React from "react";
import { Form, Row, Button } from "antd";
import { FormComponentProps } from "antd/es/form";
import { InterviewFormSection, InterviewFormItem } from "./shared";
import { InputFormDataWithInputType } from "./types";
import { updateBookingCourtDecisionData } from "../../actions/bookings";
import { PretrialDecision, Maybe } from "../../graphql-types";
import "./prospects.scss";

interface CourtDecisionFormFieldProps extends FormComponentProps {
  courtDecisionFormFieldsWithInitialValue: InputFormDataWithInputType[];
  releasedWithConditionsFormFieldsWithInitialValue: InputFormDataWithInputType[];
  sentencedFormFieldsWithInitialValue: InputFormDataWithInputType[];
  petitionResolvedFormFieldsWithInitialValue: InputFormDataWithInputType[];
  bookingId: string;
  onSubmit: () => void;
}

class CourtDecisionForm extends React.Component<CourtDecisionFormFieldProps> {
  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err: any, values: any) => {
      if (!err) {
        this.props.onSubmit();
        const { bookingId } = this.props;
        await updateBookingCourtDecisionData({
          booking_id: bookingId,
          pretrial_decision_form_data: {
            decision: values.decision,
            has_gps_monitoring: values.has_gps_monitoring,
            has_alcohol_monitoring: values.has_alcohol_monitoring,
            has_basic_monitoring: values.has_basic_monitoring,
            sentencing_decision: values.sentencing_decision,
            jail_sanction: values.jail_sanction,
          },
        });
      }
    });
  };

  render() {
    const {
      courtDecisionFormFieldsWithInitialValue,
      form,
      releasedWithConditionsFormFieldsWithInitialValue,
      sentencedFormFieldsWithInitialValue,
      petitionResolvedFormFieldsWithInitialValue,
    } = this.props;
    const { getFieldDecorator } = this.props.form;

    const decisionFieldVal = form.getFieldValue("decision");
    const decisionFieldValIsUndefined = decisionFieldVal === undefined;

    const renderReleaseOptions = (): Maybe<JSX.Element> => {
      const wasReleasedWithConditions =
        decisionFieldVal === PretrialDecision.PretrialReleaseWithConditions ||
        (decisionFieldValIsUndefined &&
          courtDecisionFormFieldsWithInitialValue[0].initialValue ===
            PretrialDecision.PretrialReleaseWithConditions) ||
        decisionFieldVal ===
          PretrialDecision.PretrialReleaseWithConditionsIfBailedOut ||
        (decisionFieldValIsUndefined &&
          courtDecisionFormFieldsWithInitialValue[0].initialValue ===
            PretrialDecision.PretrialReleaseWithConditionsIfBailedOut);

      return wasReleasedWithConditions ? (
        <>
          {releasedWithConditionsFormFieldsWithInitialValue.map(
            (releasedWithConditionsFormField) => {
              return (
                <InterviewFormItem
                  key={releasedWithConditionsFormField.id}
                  formData={releasedWithConditionsFormField}
                  getFieldDecorator={getFieldDecorator}
                />
              );
            }
          )}
        </>
      ) : null;
    };

    const renderSentenceOptions = (): Maybe<JSX.Element> => {
      const wasSentenced =
        decisionFieldVal === PretrialDecision.Sentenced ||
        (decisionFieldValIsUndefined &&
          courtDecisionFormFieldsWithInitialValue[0].initialValue ===
            PretrialDecision.Sentenced);
      return wasSentenced ? (
        <>
          {sentencedFormFieldsWithInitialValue.map((sentencedFormField) => {
            return (
              <InterviewFormItem
                key={sentencedFormField.id}
                formData={sentencedFormField}
                getFieldDecorator={getFieldDecorator}
              />
            );
          })}
        </>
      ) : null;
    };

    const renderPetitionResolvedOptions = (): Maybe<JSX.Element> => {
      const wasPetitionResolved =
        decisionFieldVal === PretrialDecision.PetitionResolved ||
        (decisionFieldValIsUndefined &&
          courtDecisionFormFieldsWithInitialValue[0].initialValue ===
            PretrialDecision.PetitionResolved);
      return wasPetitionResolved ? (
        <>
          {petitionResolvedFormFieldsWithInitialValue.map(
            (petitionResolvedFormField) => {
              return (
                <InterviewFormItem
                  key={petitionResolvedFormField.id}
                  formData={petitionResolvedFormField}
                  getFieldDecorator={getFieldDecorator}
                />
              );
            }
          )}
        </>
      ) : null;
    };

    return (
      <Form onSubmit={this.handleSubmit}>
        <InterviewFormSection
          sectionTitle={"Court Decision Information"}
          renderContents={() => (
            <>
              {courtDecisionFormFieldsWithInitialValue.map(
                (courtDecisionFormField) => {
                  return (
                    <InterviewFormItem
                      key={courtDecisionFormField.id}
                      formData={courtDecisionFormField}
                      getFieldDecorator={getFieldDecorator}
                    />
                  );
                }
              )}
              {renderReleaseOptions()}
              {renderSentenceOptions()}
              {renderPetitionResolvedOptions()}
            </>
          )}
        />
        <Row type="flex" justify="center" gutter={24}>
          <Form.Item>
            <Button type="primary" size={"large"} htmlType="submit">
              Save Court Decision
            </Button>
          </Form.Item>
        </Row>
      </Form>
    );
  }
}

export const CourtDecisionFormWrapped = Form.create<
  CourtDecisionFormFieldProps
>({
  name: "Court decision form",
})(CourtDecisionForm);
